import { render, staticRenderFns } from "./RegistrationCalculatorPage.vue?vue&type=template&id=764352fa&scoped=true"
import script from "./RegistrationCalculatorPage.vue?vue&type=script&lang=ts"
export * from "./RegistrationCalculatorPage.vue?vue&type=script&lang=ts"
import style0 from "./RegistrationCalculatorPage.vue?vue&type=style&index=0&id=764352fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "764352fa",
  null
  
)

export default component.exports